import React from 'react';
import { Route } from 'react-router-dom';
import AutenticacaoConsumer from '../providers/autenticacao/AutenticacaoConsumer';

import {
    Layout,
    Loading
} from '../presentations';

function PrivateRoute(
    {
        component,
        ...rest
    }
) {
    const renderFn = (Component) => (props) => (
        <AutenticacaoConsumer>
            {
                ({
                    isAuthenticated,
                    signinRedirect
                }) => {
                    const ud = JSON.parse(localStorage.getItem('user_data'));
                    const codigoEmpresa = ud ? ud.codigoEmpresa : null;

                    if (!!Component && isAuthenticated() && codigoEmpresa) {
                        return <Layout component={Component} {...props} />
                    }

                    signinRedirect();
                    return <Loading />
                }
            }
        </AutenticacaoConsumer>
    );

    return <Route render={renderFn(component)} {...rest} />
};

export default PrivateRoute;